var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',_vm._b({attrs:{"items":_vm.items,"item-text":"name","value":_vm.value},on:{"change":_vm.onChange}},'v-combobox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }